import { Button, Card, Flex, Form, Input, List, Modal, Radio, Table } from "antd";
import { formatNumber, monthcolumn } from "../functionLater";
import CkEditor from "../ckeditor/ckEditor";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ActivityReportInterface, BudgetReportInterface, ObjectiveReportInterface, ProgressReportPreviewInterface, OutputReportInterface } from "@/src/models/IProgress";
import { Editor } from "ckeditor5";
import { AboutResearchInterface } from "@/src/models/IAboutResearch";
import { BudgetDataInterface, UsedBudgetInterface } from "@/src/models/IBudgetData";
import { OutputFileListInterface, OutputInterface } from "@/src/models/Result";
import React from "react";
import { stringify } from "querystring";
import moment from "moment";
import { off } from "process";
import { useForm } from "antd/es/form/Form";

export function StaffProgressCheck(){
    const { progress_id } = useParams();
    const [submittedRound,setsubmittedRound] = useState(1)
    const [reviewer,setReveiewer] = useState(1)

    const navigate = useNavigate();

    const [CurrentReviewer,setCurrentReviewer] = useState('')
    const [CurrentReviewerName,setCurrentReviewerName] = useState('')
    const [LastReviewResult,setLastReviewResult] = useState('')

    const [Note,setNote] = useState('')
    const NoteRef = useRef();
    const [LastReviewSubmittedDate,setLastReviewSubmittedDate] = useState(moment())

    const [form] = useForm();

    const [isActive,setisActive]= useState(true);

    const [Keys, setExpandedRowKeys] = useState<string[]>([]);

    const {ROCKEditors,CKEditors,getHTML} = CkEditor();

    const [SubmittedConfirmation,setSubmittedConfirmation] = useState(false);

    const [OutputMod,setOutputMod] = useState(false);
    const [OutputShow,setOutputShow] = useState(false);
    const [OutputTopic,setOutputTopic]= useState('');

    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);


    const [SentedData,setSentedData]= useState<ProgressReportPreviewInterface>();
    const [ActivityReport,setActivityReport] = useState<ActivityReportInterface[]>([]);
    const [CompensationBudgetReport,setCompensationBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [OutcomeBudgetReport,setOutcomeBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [ItemExpenseBudgetReport,setItemExpenseBudgetReport] = useState<BudgetReportInterface[]>([]);
    const [ObjectiveReport,setObjectiveReport] = useState<ObjectiveReportInterface[]>([]);
    const [OutputReport,setOutputReport] = useState<OutputReportInterface[]>([]);

    const compensationUsedSum = CompensationBudgetReport.reduce((total, item) => total + Number(item.Spent || 0), 0);
    const outcomeUsedSum = OutcomeBudgetReport.reduce((total, item) => total + Number(item.Spent || 0), 0);
    const itemExpenseUsedSum = ItemExpenseBudgetReport.reduce((total, item) => total + Number(item.Spent || 0), 0);

    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)
    const handleExpand = (expanded: boolean, record: any) => {
        setisActive(true)
        if (expanded) {
            console.log(record.id)
            setExpandedRowKeys([record.id]); 
            setisActive(false)

        } else {
            setExpandedRowKeys([]); // Collapse all rows
            setisActive(false)
        }
    };

    const [compensationsum,setCompensationSum] = useState(0)
    
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)

    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)

    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [compensationUsedBudget,setCompensationUsedBudget] = useState<UsedBudgetInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeUsedBudget,setOutcomeUsedBudget] = useState<UsedBudgetInterface[]>([]);
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);
    const [itemUsedBudget,setitemUsedBudget] = useState<UsedBudgetInterface[]>([]);

    

    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [OutputProgress,setOutputProgress] = useState<OutputReportInterface[]>([])
    const [OutputFileList,setOutputFileList] = useState<OutputFileListInterface[]>([])
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    
    const ProgressSummaryRef = useRef<Editor | null>(null);
    const ProblemsAndObstacleRef = useRef<Editor | null>(null);
    const SuggestionRef = useRef<Editor | null>(null);
    const FuturePlanRef = useRef<Editor | null>(null);

    const getData = async() =>{
        await axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${sessionStorage.getItem('project_id')}/${sessionStorage.getItem('user')}`).then(async response=>{
            setDataFirst(response.data.main)

            if(response.data.main[0].period){
                const dataperiod = JSON.parse(response.data.main[0].period)
                const datamonth = dataperiod[0].split('-')
                const datamonth2 = dataperiod[1].split('-')
                setselectedmonth(Number(datamonth[1]))
                setEndMonth(Number(datamonth2[1]))
                setselectedyear(Number(datamonth[0]))
            }

            if(response.data.compensation.length!=0||response.data.outcome.length!=0||response.data.itemexpense.length!=0){
                setCompensationItems(response.data.compensation)
                setCompensationUsedBudget(response.data.compensation)
                const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setCompensationSum(totalCompensation)
                const totalMonetryCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationMonetrySum(totalMonetryCompensationBudget)
                const totalPreparedCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationPreparedSum(totalPreparedCompensationBudget)
                const totalIndirectCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationIndirectSum(totalIndirectCompensationBudget)
            
                const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setOutcomeSum(totalOutcome)
                setOutcomeItems(response.data.outcome)
                setOutcomeUsedBudget(response.data.outcome)
                const totalMonetryOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                const totalPreparedOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomePreparedSum(totalPreparedOutcomeBudget)
                const totalIndirectdOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setItemnSum(totalItem)
                setItemCost(response.data.itemexpense)
                setitemUsedBudget(response.data.itemexpense)
                const totalMonetryItemBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemMonetrySum(totalMonetryItemBudget)
                const totalPreparedItemeBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemPreparedSum(totalPreparedItemeBudget)
                const itemMonetrySum = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemIndirectSum(itemMonetrySum)
                
            }
            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setOutput(JSON.parse(response.data.main[0].output))
                setOutputProgress(JSON.parse(response.data.main[0].output))
              }
            if(response.data.main[0].ReportStatus=='มีข้อแก้ไข'||response.data.main[0].ReportStatus=='ยืนยัน'){

            }
          
              setisActive(false)
        })
    }

    const getFilelist = async(Output:any) =>{
        const data = {
            Output : Output
        }

        axios.post(`${process.env.REACT_APP_BASE}/getOutputFileList/${sessionStorage.getItem('project_id')}/${SentedData?.SentOrder}`,data).then(response=>{
            if(response.status==200){
                setOutputFileList(response.data)
                setOutputTopic(Output)
                setOutputMod(true)
            }
        })
    }

    const viewFile = async(Output:any,FileID:number)=>{
        const data = {
            Output:Output,
        }
        await axios.post(`${process.env.REACT_APP_BASE}/GetOutputFile/${FileID}`,data,
        { responseType: 'blob' }).then(response=>{
            if (response.status === 200) {

                const blob = response.data; 
                const blobUrl = URL.createObjectURL(blob);
    
                setPreviewUrl(blobUrl); 
            }
        })

    }

    const expandedRowRender = (tempdata: any) => {
        let dataSource:  any[] | undefined = [];
  
        const category = tempdata.category
  
        if (tempdata.category === 'compensation') {
          dataSource = CompensationBudgetReport;
        } else if (tempdata.category === 'outcome') {
          dataSource = OutcomeBudgetReport;
        } else if (tempdata.category === 'itemexpense') {
          dataSource = ItemExpenseBudgetReport;
        }
      
        return <>
          <Table
              columns={[
                  {
                      title:'',
                      dataIndex: 'BudgetDetail',
                      key: 'BudgetDetail',
                      width: 450,
                  },
                  {
                      title:'',
                      dataIndex: 'Budget',
                      key: 'Budget',
                      width: 250,
                      render: (_, record) => (
                      <Flex justify="center">{formatNumber(record.Budget)}</Flex>
                      ),},
                  {
                      title:'',
                      dataIndex: 'Spent',
                      key: 'Spent',
                      width: 250,
                      render: (_, record) => (
                        <Flex justify="center">{formatNumber(record.Spent)}</Flex>
                        ),
                  },
                  {
                    title:'',
                    dataIndex: 'note',
                  }
              ]}
              showHeader={false} 
              pagination={false}
              dataSource={dataSource}/>
        </>
      }

    const GetReport = async()=>{
        axios.get(`${process.env.REACT_APP_BASE}/GetProgressData/${progress_id}/${sessionStorage.getItem('head_user')}`).then(async response=>{
            if(response.status==200){
                setSentedData(response.data.main[0])
                setActivityReport(response.data.activity)
                setCompensationBudgetReport(response.data.compensationbudget)
                setOutcomeBudgetReport(response.data.outcomebudget)
                setItemExpenseBudgetReport(response.data.itemexpensebudget)
                setObjectiveReport(response.data.obj)
                console.log(response.data.output)
                setOutputReport(response.data.output)

                await axios.get(`${process.env.REACT_APP_BASE}/getProgressReportReview/${response.data.main[0].ProgressReportID}`).then(resp=>{
                    if(resp.status==200){
                        console.log(resp.data)
                        setNote(resp.data.note)
                        setCurrentReviewer(resp.data.PositionName)
                        setCurrentReviewerName(resp.data.ReviewerName)
                        setLastReviewResult(resp.data.ApprovedStatus)
                        setLastReviewSubmittedDate(moment(resp.data.SummittedDate))
                    }
                })
            }
        })
    }

    const PostInfo = async() =>{
        const FormData = form.getFieldsValue();

        const data = {
            ApprovedStatus:FormData?.ApprovedStatus,
            note:FormData?.ApprovedStatus,
            Approver:sessionStorage.getItem('user'),
            ApproverName:sessionStorage.getItem('fullname'),
            ApproverPosition:sessionStorage.getItem('PositionName'),
            CompletionStatus:'Progressed',
        }

        axios.post(`${process.env.REACT_APP_BASE}/SetReportReview/${progress_id}`,data).then(response=>{
            if(response.status==200){
                navigate(`/VRIIS/ProgressReportList`);
            }
        })

    }

    useEffect(()=>{
        GetReport();
        getData()
    },[]);

    return(<>
     <h1 className="text-3xl font-semibold ">รายงานความก้าวหน้าของโครงการครั้งที่ {SentedData?.SentOrder}</h1>
    <br/>
    <hr/>
    <br/>
    <p><span style={{fontWeight:'bold'}}>ชื่อโครงการ :</span> {SentedData?.project_name_th}&nbsp;</p>
    <p><span style={{fontWeight:'bold'}}>ผู้ยื่นโครงการ :</span> {SentedData?.head_name_th} &nbsp;</p>
    <p className="font-bold leading-relaxed" >รายงานผลการดำเนินการวิจัย และการวิเคราะห์ผลการวิจัย</p>
    <Table
        columns={[
            {
              title:'แผนการการดำเนินงาน',
              dataIndex:'ActivityName',
              fixed: 'left',  
              width: 200,  
              className: 'fixed-column'
            },
            {
              title:'ระยะเวลาที่ทำกิจกรรม',
              children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])
            },{
              title:'ความสำเร็จต่อโครงการ',
              fixed: 'right',  
              className: 'fixed-column',
              render: (_, record,index) =>(
                <>
                    <Flex justify='center'>
                        {ActivityReport[index]?.ActivityRatio} %
                    </Flex>
                </>
              )
            },{
              title:'หมายเหตุ',
              fixed: 'right',  
              width: 200, 
              className: 'fixed-column',
              render: (_, record,index) =>(
                <>
                    <Flex justify='center'>
                        {ActivityReport[index]?.note}
                    </Flex>
                </>
              )
            }
        ]}
        scroll={{ x: 'max-content' }}
        pagination={false}
        dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
        />
    <p className="font-bold leading-relaxed" >รายละเอียดของขั้นตอนการดำเนินงานจริงตามแผนงาน (ช่วงรายงานผล) </p>
    <Table
        columns={[
            {
                title:'วัตถุประสงค์', 
                dataIndex:'ActivityName',
                width:'20vw'
            },
            {
                title:'สิ่งที่ดำเนินการ',
                dataIndex:'SixMonthProgress',
                width:'40vw',
                render: (_, record,index) =>(
                    <>
                        <p dangerouslySetInnerHTML={{ 
                            __html: (record?.SixMonthProgress )
                        }}/>
                    </>
                  )
                
            },
            {
                title:'สิ่งที่จะดำเนินการ',
                dataIndex:'SixMonthPlan',
                width:'40vw',
                render: (_, record,index) =>(
                    <>
                        <p dangerouslySetInnerHTML={{ 
                            __html: (record?.SixMonthPlan )
                        }}/>
                    </>
                  )

            }
            
        ]}
        pagination={false}
        dataSource={ObjectiveReport}
        />
        <br/>
    <p className="font-semibold">สรุปผลการดำเนินงาน</p>
    <ROCKEditors 
        myRef={ProgressSummaryRef}
        htmlBox={SentedData?.ProgressionSummary}
        />
    <p className="font-semibold">ปัญหาและอุปสรรค</p>
    <ROCKEditors
        myRef={ProblemsAndObstacleRef}
        htmlBox={SentedData?.ProblemAndObstacle}/>
    <p className="font-semibold">คำแนะนำและข้อมูลเพิ่มเติมอื่นๆ (ถ้ามี) </p>
    <ROCKEditors
        myRef={SuggestionRef}
        htmlBox={SentedData?.SuggestionAndInformation}/>
    <br/>
    <p className="font-semibold">รายจ่ายที่เกิดขึ้นจริง รอบ 6 เดือน</p>
    <Table
        rowKey="id"
        columns={[
            {
                title:'หมวดรายการงบประมาณ',
                dataIndex:'detail',
                width: 450,
            },
            {
                title:'งบประมาณ (บาท)',
                width: 500,
                children:[
                    {
                        title:'งบประมาณที่ได้รับ',
                        width: 250,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.MonetrySum+record.PreparedSum+record.IndirectSum)}</Flex>
                        ),},
                    {
                        title:'จำนวนเงินที่ใช้ไป',
                        width: 250,
                        render: (_, record) => (
                          <>
                            <Flex justify="center">
                                <p>{formatNumber(record.Usedsum)}</p>
                            </Flex>
                          </>
                    )},
                ]
            },
            {
                title:'หมายเหตุ',
                render: (_, record) => (
                    <>
                      <Flex justify="center">
                        <p>-</p>
                      </Flex>
                    </>
              )
            },
        ]}
        expandable={{
            expandedRowRender,
            expandedRowKeys: Keys,
            onExpand: handleExpand,
            rowExpandable: (record) => {
                if (record.category === 'compensation') return compensationItems.length > 0;
                if (record.category === 'outcome') return OutcomeItems.length > 0;
                if (record.category === 'itemexpense') return ItemCost.length > 0;
                return false;
              },
        }}
        scroll={{ x: 'max-content' }}
        dataSource={[
            {
              id: 1,
              detail: 'หมวดค่าตอบแทน',
              category:'compensation',
              sum:compensationsum,
              Usedsum:compensationUsedSum,
              MonetrySum:compensationMonetry,
              PreparedSum:compensationPrepared,
              IndirectSum:compensationIndirect
            },
            {
              id: 2,
              detail: 'หมวดค่าใช้จ่าย',
              category:'outcome',
              sum:outcomesum,
              Usedsum:outcomeUsedSum,
              MonetrySum:outcomeMonetry,
              PreparedSum:outcomePrepared,
              IndirectSum:outcomeIndirect
            },
            {
                id: 3,
                detail: 'หมวดค่าวัสดุ และอุปกรณ์',
                category:'itemexpense',
                sum:itemsum,
                Usedsum:itemExpenseUsedSum,
                MonetrySum:itemMonetry,
                PreparedSum:itemPrepared,
                IndirectSum:itemIndirect
              },
              {
                id: 4,
                detail: 'รวม',
                category:'',
                sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
                Usedsum:compensationUsedSum + outcomeUsedSum + itemExpenseUsedSum,
                MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
                PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
                IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
              }
          ]}
        pagination={false}
        />
    <p className="font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>

    <Table
        columns={[
            {
                title:'ผลผลิต',
                dataIndex:'Output_name',
                fixed: 'left',  
                width: 200,  
                className: 'fixed-column'
            },{
                title: 'จำนวนนำส่ง/หน่วยนับ',
                dataIndex:'Output_amount',
                key: 'Output_amount',
            },{
                title:'รายละเอียดผลผลิต',
                dataIndex:'Output_description',
                key: 'Output_description',
            },{
                title:'ปีที่นำส่งผลผลิต',
                dataIndex:'SentYear',
                key: 'SentYear',
                render: (_, record) => (
                    <>
                        <Flex justify='center'>
                            <p>{moment(record?.SentYear)?.format('YYYY')}</p>
                        </Flex>
                    </>
                  ), 
            },{
                title:'เปอร์เซ็นความก้าวหน้าการดำเนินงาน',
                dataIndex:'Progresspercentage',
                key: 'Progresspercentage',
                render: (_, record) => (
                    <>
                        <Flex justify='center'>
                            <p>{record?.Progresspercentage&&record?.Progresspercentage.toString()||0} %</p>
                        </Flex>
                    </>
                  ), 
            },{
                title:'ผลผลิตที่เกิดขึ้นจริง',
                dataIndex:'RealOutput',
                key: 'RealOutput',
            },{
                title:'หลักฐาน/เอกสารประกอบ',
                dataIndex:'Attachment',
                key: 'Attachment',
                render: (_, record) => (
                    <>
                        <p dangerouslySetInnerHTML={{ 
                            __html: (record?.Attachment)
                        }}/>
                    </>
                  ), 
            },{
                title:'ไฟล์แนบ',
                width: 200,
                render: (_, record) => (
                    <>
                        <Flex justify='center'>
                            <Button 
                            onClick={()=>{
                                getFilelist(record.Output_name)
                            }}>ดูข้อมูลไฟล์ที่อัพโหลด</Button>
                        </Flex>
                    </>
                  ), 
            }
        ]}
        scroll={{ x: 'max-content' }}
        pagination={false}
        dataSource={OutputReport}
        />

    <br/>
    <h1 className="text-3xl font-semibold ">ผลการอนุมัติโครงการ</h1>

    {SentedData?.ReportStatus=='ยื่นความคืบหน้าโครงการ'&&<Card>
        <Form form={form} layout='vertical'>
            <Form.Item
            name='ApprovedStatus'
            label={<p style={{ fontWeight: 'bold' }}>ผลของรายงานคือ</p>}
            >
            <Radio.Group style={{marginLeft:'5vw'}}>
                <Radio value='ผ่าน'>
                    ผ่าน
                </Radio>
                <Radio value='มีข้อแก้ไข'>มีข้อแก้ไข</Radio>
            </Radio.Group>
            </Form.Item>

            <Form.Item
            name='note'
            label={<p style={{ fontWeight: 'bold' }}>บันทึกข้อความ</p>}
            >
            <TextArea style={{ width: '100%' }} autoSize/>
            </Form.Item>

            <Flex justify='center'>
            <Button onClick={() => setSubmittedConfirmation(true)}>
                ส่งผลการอนุมัติ
            </Button>
            </Flex>

            <Modal
            title='ยืนยันผล'
            open={SubmittedConfirmation}
            onCancel={() => setSubmittedConfirmation(false)}
            footer={null}
            >
                <hr />
                <p>คุณต้องการยืนยันผลการตรวจสอบหรือไม่</p>
                <Flex justify='flex-end'>
                    <Button danger onClick={()=> setSubmittedConfirmation(false)}>ยกเลิก</Button>&nbsp;&nbsp;
                    <Button onClick={()=>PostInfo()}>บันทึก</Button>
                </Flex>
            </Modal>
        </Form>
    </Card>||
    <Card>
        <p>ผู้ลงผลอนุมัติ : {CurrentReviewerName}</p>
        <p>สถานะ : {SentedData?.ReportStatus}</p>    
        <p>บันทึกข้อความ : </p>
        <Card style={{marginLeft:'3vw'}}>
            <p>{Note ?? 'ไม่มีข้อมูล'}</p>
        </Card>
        <br/>
        <Flex justify='center'>
            <Button type='primary' href={`${process.env.REACT_APP_BASE}/exportProgressRep/${progress_id}/${sessionStorage.head_user}`}>ดาวน์โหลดข้อมูลโครงการ</Button>
        </Flex>
    </Card>}
    <Modal
    title={`รายชื่อไฟล์ที่เพิ่มเข้ามาในระบบ : ${OutputTopic}`}
    open={OutputMod}
    onCancel={()=>{setOutputMod(false)
        setPreviewUrl(null)}}
    footer={<></>}
    >
         <List
        bordered
        renderItem={(item, index) =>(
            <><List.Item
                actions={[
                    <> 
                        <a onClick={()=>viewFile(item.Output,item.FileID)}>ดูไฟล์</a>
                    </>
                    ]}>
                <List.Item.Meta
                    title={<p>{item.Filename}</p>}
                />
            </List.Item>
                <br/>
            
            </>
        )}
        dataSource={OutputFileList}/>
        <br/>
         {previewUrl&&<>
            <iframe src={previewUrl} 
                width="100%"
                height="600px"
                title="PDF Viewer"/>
        </>}
    </Modal>

    </>)
}